
export const Fetcher = ({host="", headers=null}) => {

    const readJsonResponse = async (res) => {
        if (res.status >= 400 && res.status <= 599) {
            throw {
                status: res.status,
            };
        }
        try {
            const responseBody = await res.text();
            return JSON.parse(responseBody)
        }
        catch (err) {
            return null;
        }
    };

    const fetchJson = async (url, {body=undefined, options, useCredentialsSameOrigin=false}) => {
        const res = await fetch(url, {
            credentials: (useCredentialsSameOrigin) ? "same-origin" : "include",
            ...body != null ? {
                body: JSON.stringify(body),
                headers: {
                    "Accept": "application/json",
                    "content-type": "application/json",
                    ...headers,
                },
            } : {
                headers: {...headers},
            },
            ...options,
        });
        return await readJsonResponse(res);
    };

    const fetchMultipart = async (url, {keyValuePairs, options, useCredentialsSameOrigin=false}) => {

        const formData = new FormData();
        for (let key in keyValuePairs) {
            formData.append(key, keyValuePairs[key]);
        }

        const res = await fetch(url, {
            credentials: (useCredentialsSameOrigin) ? "same-origin" : "include",
            body: formData,
            headers: {...headers},
            ...options,
        });
        return await readJsonResponse(res);
    };

    return {
        postJson: async (url, data, useCredentialsSameOrigin=false) => {
            return await fetchJson(host + url, {
                body: data,
                options: {
                    method: "POST"
                },
                useCredentialsSameOrigin: useCredentialsSameOrigin,
            });
        },
        getJson: async (url, useCredentialsSameOrigin=false) => {
            return await fetchJson(host + url, {
                options: {
                    method: "GET"
                },
                useCredentialsSameOrigin: useCredentialsSameOrigin,
            });
        },
        postMultipart: async (url, data, useCredentialsSameOrigin=false) => {
            return await fetchMultipart(host + url, {
                keyValuePairs: data,
                options: {
                    method: "POST"
                },
                useCredentialsSameOrigin: useCredentialsSameOrigin,
            });
        },
        putJson: async (url, data, useCredentialsSameOrigin=false) => {
            return await fetchJson(host + url, {
                body: data,
                options: {
                    method: "PUT"
                },
                useCredentialsSameOrigin: useCredentialsSameOrigin,
            });
        },
        deleteJson: async (url, data="", useCredentialsSameOrigin=false) => {
            return await fetchJson(host + url, {
                body: data,
                options: {
                    method: "DELETE"
                },
                useCredentialsSameOrigin: useCredentialsSameOrigin,
            });
        },
    };
};